module.exports = __webpack_public_path__ + "media/images/application2/AppPublisher__package__buttons__a--preview-a8bc7ee4a7b93662b78db3c83335c45d.svg";